import React, { ReactNode } from 'react';
import Button from './Button';

interface ModalPaneProps {
  isOpen: boolean;
  title: string | ReactNode;
  onClose: () => void;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  footer?: ReactNode;
}

const ModalPane: React.FC<ModalPaneProps> = ({
  isOpen,
  title,
  onClose,
  children,
  size = 'lg',
  footer
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
    full: 'max-w-[90%] max-h-[90vh]'
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center pt-10 z-50 overflow-y-auto">
      <div className={`bg-white rounded-lg overflow-hidden shadow-xl w-[95%] ${sizeClasses[size]}`}>
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onClose}
            aria-label="Fechar"
          >
            <i className="fas fa-times"></i>
          </Button>
        </div>
        
        {/* Content */}
        <div className="px-6 py-4 overflow-auto max-h-[calc(90vh-8rem)]">
          {children}
        </div>
        
        {/* Footer */}
        {footer && (
          <div className="px-6 py-3 bg-gray-50 border-t border-gray-200 flex justify-end space-x-2">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalPane;